<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'CustomerView',
  mounted() {
    try {
      this.$store.dispatch('CustomerModule/fetchAllCustomers', { page: 1, limit: 20 });
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>

</style>
